import React, { useEffect, useState } from 'react';
import { useWindowDimensions } from '../../../../utils/util';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import styles from './styles.module.css';
import CouponCard from './CouponCard/CouponCard';
import CreateModal from './createModal/CreateModal';
import EditModal from './createModal/EditModal';
import { viewCouponByUser, deleteCouponSlot } from '../../../../store/actions/coupon';
import { toast } from 'react-toastify';

function TeacherCoupons() {
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const tableHeader = ['All Coupons', 'Redeemed', 'Expired'];

  const [page] = useState(0);
  const [coupons, setCoupons] = useState([]);
  const [searchQuery, setSearchQuery] = useState('All Coupons');
  const [createModal, setCreateModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [mobileDropdown, setMobileDropdown] = useState(false);
  const [activeTab] = useState('Coupons');
  const [teacherName, setTeacherName] = useState('');
  const [apiCall, setApiCall] = useState(false);

  const handleEdit = (coupon) => {

    setEditUser(coupon);
    setEditModal(true);
  };

  const handleDelete = async (couponId) => {
    if (!window.confirm('Are you sure you want to delete this coupon?')) {
      return;
    }


    try {
      const result = await dispatch(deleteCouponSlot(couponId));
      if (result.status !== false) {
        toast.success('Coupon deleted successfully');
        setApiCall(prev => !prev);
      } else {
        toast.error(result.msg || 'Failed to delete coupon');
      }
    } catch (error) {
      console.error('Error deleting coupon:', error);
      toast.error('Failed to delete coupon');
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const storedTeacher = JSON.parse(localStorage.getItem('teacherData'));
      const profile = JSON.parse(localStorage.getItem('profile'));






      if (storedTeacher?.firstName?.data) setTeacherName(storedTeacher.firstName.data);

      if (!profile?.token?.access) {
        console.error('❌ No authentication token found');
        setCoupons([]);
        return;
      }

      if (profile?.role !== 'Teacher') {
        console.error('❌ User is not a teacher. Role:', profile?.role);
        setCoupons([]);
        return;
      }

      try {

        const result = await dispatch(viewCouponByUser(searchQuery, page));


        if (result?.success && Array.isArray(result.data)) {

          setCoupons(result.data);
        } else if (Array.isArray(result)) {

          setCoupons(result);
        } else if (result?.data && Array.isArray(result.data)) {

          setCoupons(result.data);
        } else if (result?.coupons && Array.isArray(result.coupons)) {

          setCoupons(result.coupons);
        } else {

          setCoupons([]);
        }
      } catch (error) {
        console.error('❌ Error fetching coupons:', error);
        setCoupons([]);
      }
    };
    fetchData();
  }, [searchQuery, page, dispatch, apiCall]);

  return (
    <>
      {createModal && (
        <CreateModal
          setCreateModal={setCreateModal}
          width={width}
          coupons={coupons}
          setCoupons={setCoupons}
          setApiCall={setApiCall}
        />
      )}

      {editModal && editUser && (
        <EditModal
          setEditModal={setEditModal}
          width={width}
          editUser={editUser}
          setEditUser={setEditUser}
          setApiCall={setApiCall}
        />
      )}

      <main className={styles.mainSection}>
        {width >= 992 ? (
          <div className={styles.sessionTabs}>
            <h1>Coupons</h1>
            <div className={styles.sessionshow}>
              {tableHeader.map((item, index) => (
                <div
                  key={index}
                  className={`${styles.sessionTab} ${searchQuery === item ? styles.sessionTabActive : ''}`}
                  onClick={() => setSearchQuery(item)}
                >
                  {item}
                </div>
              ))}
              <div
                className={styles.sessionTabAdd}
                style={{ margin: '0 20px' }}
                onClick={() => setCreateModal(true)}
              >
                <span className="fa fa-plus"></span>
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.sessionTabs}>
            <div className={styles.sessionTabHeading}>{activeTab}</div>
            <div className={styles.arrowIcon} onClick={() => setMobileDropdown(!mobileDropdown)}>
              {mobileDropdown ? <i className="fas fa-caret-up"></i> : <i className="fas fa-caret-down"></i>}
            </div>
          </div>
        )}

        {coupons.length > 0 ? (
          coupons.map((item, index) => (
            <CouponCard
              key={index}
              CourseName={item.couponCode}
              teacherName={teacherName}
              expDate={moment(item.validTill).format('MMMM DD, YYYY')}
              price={item.discountAmt}
              onEdit={() => handleEdit(item)}
              onDelete={() => handleDelete(item.id || item._id)}
            />
          ))
        ) : (
          <div style={{ textAlign: 'center', marginTop: 20 }}>No Coupons</div>
        )}
      </main>
    </>
  );
}

export default TeacherCoupons;
